import { FunctionComponent, PropsWithChildren } from 'react'
import classNames from 'classnames'

import { Layout, Page } from '@matillion/component-library'

import AppHeader from './AppHeader'
import AppFooter from './AppFooter'
import classes from './AppLayout.module.scss'

const AppLayout: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <Layout header={<AppHeader />} footer={<AppFooter />}>
    <Page>
      <div className={classNames(classes.AppLayout__Page)}>{children}</div>
    </Page>
  </Layout>
)

export default AppLayout
